import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {
    getCashierLiquidationPreviewAPI,
    getPrevLiquidationPreviewAPI,
    insertCashierLiquidationAPI
} from "../../api/cashierLiquidation";

export const fetchCurrentLiquidationsPreview =
    createAsyncThunk('getCashierLiquidationPreviewAPI', async (data) => {
    return await getCashierLiquidationPreviewAPI(data)
})
export const fetchHistoryLiquidationsPreview =
    createAsyncThunk('getPrevLiquidationPreviewAPI', async (data) => {
    return await getPrevLiquidationPreviewAPI(data)
})

export const insertCashierLiquidation = createAsyncThunk(
    'insertCashierLiquidationAPI',
    async (payload) => {
        return await insertCashierLiquidationAPI(payload);
    }
);


const initialState = {
    foundLiquidations: undefined,
    foundHistoryLiquidations: undefined,
    loadingLiquidations: false,
    loadingHistoryLiquidations: false
}

const liquidationSlice = createSlice({
    name: 'liquidation',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCurrentLiquidationsPreview.pending, (state) => {
                state.loadingLiquidations = true;
            })
            .addCase(fetchCurrentLiquidationsPreview.fulfilled, (state, {payload}) => {
                if (payload?.data) {
                    state.foundLiquidations = payload.data;
                }
                state.loadingLiquidations = false;
            })
            .addCase(fetchCurrentLiquidationsPreview.rejected, (state) => {
                state.loadingLiquidations = false;
            })
            .addCase(fetchHistoryLiquidationsPreview.pending, (state) => {
                state.loadingHistoryLiquidations = true;
            })
            .addCase(fetchHistoryLiquidationsPreview.fulfilled, (state, {payload}) => {
                if (payload?.data) {
                    state.foundHistoryLiquidations = payload.data;
                }
                state.loadingHistoryLiquidations = false;
            })
            .addCase(fetchHistoryLiquidationsPreview.rejected, (state) => {
                state.loadingHistoryLiquidations = false;
            })
            .addCase(insertCashierLiquidation.pending, (state) => {
                state.loadingLiquidations = true;
            })
            .addCase(insertCashierLiquidation.fulfilled, (state,action) => {
                state.foundLiquidations = state.foundLiquidations.filter(
                    i => i.cashier !== action.meta.arg.cashier
                );
                state.loadingLiquidations = false;
            })
            .addCase(insertCashierLiquidation.rejected, (state) => {
                state.loadingLiquidations = false;
            });
    },
});
export default liquidationSlice.reducer;
